<script>
    export let isAttentionVisible = false;
    import { trainerTexts } from './trainerTexts.js';
    export let lang;
</script>

<div
    class="sidebar__attention"
    on:click={() => {
        isAttentionVisible = false;
    }}
>
    <h1 class="btn-text__main">{trainerTexts[lang].attention_sidebar}</h1>
</div>
